/* src/app/modules/institutions/institutions-documents/institutions-documents.component.scss */
/*# sourceMappingURL=institutions-documents.component.css.map */
